import { render, staticRenderFns } from "./FraudCheckQueueDetail.vue?vue&type=template&id=af9a115e&scoped=true"
import script from "./FraudCheckQueueDetail.vue?vue&type=script&lang=ts"
export * from "./FraudCheckQueueDetail.vue?vue&type=script&lang=ts"
import style0 from "./FraudCheckQueueDetail.vue?vue&type=style&index=0&id=af9a115e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9a115e",
  null
  
)

export default component.exports